import { getSortedPlans } from "QuotePage/Selectors";

import { getPlanById } from "Common/PlanLoader/Selectors";

import type { State } from "QuotePage/Store";
import type { RecommendationMode, MedicalPlanPrice } from "Utils/types";

export const getRecommendationMode = (state: State): RecommendationMode => state.filters?.recommendation_mode;

export const getVisiblePlansRecommendationMode = (state: State): Array<MedicalPlanPrice> => {
  if (state.recommendedPlans && state.recommendedPlans.length > 0) {
    return state.recommendedPlans.map((planInfo) => getPlanById(state, planInfo.id)).filter((p) => p);
  }
  return getSortedPlans(state).slice(0, 3);
};
